const set = {
	prpcow: "initial.prpcow",
};
const initialConstants = Object.seal(set);
export default initialConstants;
